import React from "react"
import { useFooterMenu3 } from "../../hooks/use-footer-menu-3"
import Link from "../link"

export const FooterMenu3 = () => {
  const [menuItems] = useFooterMenu3()

  return (
    <ul className="list-unstyled">
      {menuItems.map((node) => {
        const { id = '', label = '', url = '' } = node
        return (
          <li key={id}>
            <Link 
              to={url}>
              {label}
            </Link>
          </li>
        )
      })}
    </ul>
  )
}